<script setup>
defineProps({
  image: {
    type: Object,
    required: true,
  },
  type: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div :class="type" class="decoration-img">
    <DefaultPicture
      :image="{
        custom: image.responsiveImage,
      }"
      :lazy-load="true"
      alt="Istituto Canossiano"
    />
  </div>
</template>

<script>
export default {
  name: 'DecorationImage',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
